import React from 'react';
import { useLocation } from 'react-router-dom';
import { FaCheckCircle, FaTimesCircle, FaHome, FaListAlt } from 'react-icons/fa';
import './PaymentStatus.css';

function PaymentStatus() {
  const location = useLocation();
  const { state } = useLocation();
  const queryParams = new URLSearchParams(location.search);
  
  // Get status from URL params or default to success for demo
  const isSuccess = queryParams.get('status') !== 'failed';
  const transactionId = queryParams.get('txn_id') || 'TXN_' + Math.random().toString(36).substr(2, 9).toUpperCase();
  const amount = state?.amount || '0.00';
  const currency = queryParams.get('currency') || 'TZS';
  const tranId = state?.trans_id


  return (
    <div className={`payment-status-container ${isSuccess ? 'success' : 'failed'}`}>
      <div className="payment-status-icon">
        {isSuccess ? (
          <FaCheckCircle className="icon-success" />
        ) : (
          <FaTimesCircle className="icon-failed" />
        )}
      </div>
      
      <h2 className="payment-status-title">
        {isSuccess ? 'Payment Successful!' : 'Payment Failed'}
      </h2>
      
      <div className="payment-status-content">
        {isSuccess ? (
          <>
            <p>Your payment of <strong>{currency} {parseFloat(amount).toFixed(2)}</strong> has been successfully processed.</p>
            <p className="transaction-id">Transaction ID: {tranId}</p>
            <p>Thank you for your purchase! A receipt has been sent to your email.</p>
          </>
        ) : (
          <>
            <p>We couldn't process your payment of <strong>{currency} {parseFloat(amount).toFixed(2)}</strong>.</p>
            <p>Please try again or use a different payment method.</p>
            <p className="error-message">Error: {queryParams.get('error') || 'Payment processing failed'}</p>
          </>
        )}
      </div>
      
      <div className="payment-status-details">
        <div className="detail-row">
          <span>Date:</span>
          <span>{new Date().toLocaleString()}</span>
        </div>
        <div className="detail-row">
          <span>Amount:</span>
          <span>{currency} {parseFloat(amount).toFixed(2)}</span>
        </div>
        {isSuccess && (
          <div className="detail-row">
            <span>Status:</span>
            <span className="status-badge success">Completed</span>
          </div>
        )}
      </div>
      
      <div className="payment-status-actions">
        <button className="btn btn-primary" onClick={() => window.location.href = '/'}>
          <FaHome /> Go to Home
        </button>
        {isSuccess ? (
          <button className="btn btn-secondary" onClick={() => window.location.href = '/user-classes'}>
            <FaListAlt /> View My Classes
          </button>
        ) : (
          <button className="btn btn-retry" onClick={() => window.location.href = '/checkout'}>
            Retry Payment
          </button>
        )}
      </div>
    </div>
  );
}

export default PaymentStatus;